import { render } from "./SobreView.vue?vue&type=template&id=1d602200&lang=pug"
import script from "./SobreView.vue?vue&type=script&setup=true&lang=js"
export * from "./SobreView.vue?vue&type=script&setup=true&lang=js"

import "./SobreView.vue?vue&type=style&index=0&id=1d602200&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__